import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=19338230&scoped=true&"
import script from "./StepFour.vue?vue&type=script&lang=js&"
export * from "./StepFour.vue?vue&type=script&lang=js&"
import style0 from "./StepFour.vue?vue&type=style&index=0&id=19338230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19338230",
  null
  
)

export default component.exports